import { Icon, IconProps } from '@/components/icon/Icon';
import Popover, { PopoverBaseProps } from '@/components/popover/Popover';
import useTranslation from 'next-translate/useTranslation';
import { cn } from '../_utils/cn';

export interface LegendItemType {
	title: string;
	description: string;
	icon?: IconProps;
}

export interface LegendDataType extends Array<LegendItemType> {}

export interface LegendPopoverPropsType extends Partial<PopoverBaseProps> {
	popoverContentClass?: string;
	legendData: LegendDataType;
}

export default function LegendPopover(legendPopoverProps: LegendPopoverPropsType) {
	const { popoverContentClass, legendData, ...popoverProps } = legendPopoverProps;

	const { t } = useTranslation();
	return (
		<Popover
			positions={'bottom'}
			arrowSize={10}
			{...popoverProps}
			popoverContent={
				<div
					className={`${cn('flex max-h-[400px] w-[400px] flex-col gap-xl rounded-lg bg-dark-800 p-3xl drop-shadow-[0px_1px_3px_rgba(0,0,0,0.3)]', popoverContentClass)}`}>
					<div className='flex flex-none justify-between gap-3'>
						<p className='text-sm text-dark-300'>{t('common:legend')}</p>
						<div className='btn-transition' onClick={popoverProps.setIsOpen}>
							<Icon name='crossIcon' size='md' variant='dark300' />
						</div>
					</div>
					<div className={`flex-1 overflow-auto rounded-sm bg-dark-900 px-2xl`}>
						{legendData.map((itemLegend, i) => (
							<div
								key={i}
								className={`flex items-center justify-between gap-2xl py-xl [&:not(:last-child)]:border-b-[1px] [&:not(:last-child)]:border-dark-700`}>
								<div className='grid gap-xs'>
									<div className='text-md font-semibold'>{itemLegend.title}</div>
									<div className='text-md text-dark-200'>{itemLegend.description}</div>
								</div>
								{itemLegend.icon && (
									<div>
										<Icon {...itemLegend.icon} />
									</div>
								)}
							</div>
						))}
					</div>
				</div>
			}>
			{popoverProps?.children ? (
				popoverProps.children
			) : (
				<Icon name='questionMarkCircleIcon' variant='primary' className='btn-transition select-none' />
			)}
		</Popover>
	);
}
